import { Col, Row } from "antd";
import PropTypes from "prop-types";
import { filter, find } from "lodash";
import React, { Component } from "react";
import {
  DisplayFlex,
  SectionContent,
} from "../../../../../../CommonComponents/commonStyles";
import {
  AlertContent,
  Types,
} from "../../../../../../CommonComponents/ContentMessages";
import ErrorPopup from "../../../../../../CommonComponents/ErrorPopup/ErrorPopup";
import { formatAmount } from "../../../../../../utils/commonUtil";
import regexMap from "../../../../../../utils/regexMap";
import { AlertWrap, ErrorMsgWrap, LabelDataHeading } from "../../style";
import { GrantAllocationSwitch } from "../RenderCard/style";
import tabConfigColumn from "./config";
import GrantAllocationCard from "./GrantAllocationCard";
import { CustomTable, GrantAllocationFooter } from "./style";
import { replaceSelect } from "../../../../../../utils/replacer";
export default class GrantAllocationTable extends Component {
  constructor(props) {
    super(props);
    const allSharesAllPoolsSelected =
      props.allSharesAllPoolsOnly || props.allSharesAllPools;
    this.state = {
      radioChangePopup: false,
      showAllPoolsPopup: false,
      allShareAllPoolsCheck: allSharesAllPoolsSelected,
      allSharesCheck: props.allShares || false,
      allocType: props.allocationPreference || "byDollars",
      allocTypeReq: "",
      grantAmount: props.amount,
      showPool90PercentWarning: false,
      showPoolBalanceExceedError: false,
      activePoolName: "",
      showAllShareFirstPopup: false,
      record: "",
      fromAllShare: false,
      grantAmountOrPercentFieldChange: false,
      grantAllocation: props.allocations.length
        ? this.prefillTableData(
            props.allocationData,
            props.allocations,
            props.amount,
            allSharesAllPoolsSelected
          )
        : this.createTableData(
            props.allocationData,
            props.allocationPreference,
            props.amount,
            allSharesAllPoolsSelected,
            props.availableBalance
          ),
    };
  }

  componentDidMount() {
     this.handleChange();
  }

  componentWillReceiveProps(newProps) {
    if (
      this.props.allocationPreference !== newProps.allocationPreference ||
      this.props.scheduleType !== newProps.scheduleType ||
      (this.props.amount !== newProps.amount &&
        !(this.state.allShareAllPoolsCheck || this.state.allSharesCheck))
    ) {
      const newAllocation = this.createTableData(
        newProps.weightedAllocEdit
          ? this.state.grantAllocation
          : newProps.allocationData,
        newProps.allocationPreference,
        newProps.amount,
        null,
        newProps.availableBalance,
        newProps.weightedAllocEdit
      );
      this.setState(
        {
          grantAllocation: newProps.weightedAllocEdit
            ? this.state.grantAllocation
            : newAllocation,
          allShareAllPoolsCheck: false,
          allSharesCheck: false,
          grantAmount: newProps.amount,
          allocType: newProps.allocationPreference,
          showPoolBalanceExceedError: false,
          grantAmountOrPercentFieldChange: false,
        },
        this.handleChange
      );
    }
  }

  createTableData = (
    pools,
    preference,
    amount,
    allSharesAllPools,
    availableBalance,
    weightedAllocEdit
  ) => {
    if (
      preference === "weightedAllocations" ||
      (preference === "byDollars" &&
        weightedAllocEdit &&
        amount &&
        availableBalance)
    ) {
      return this.createPoolsForWeightedAlloc(pools, amount, availableBalance);
    }
    return pools.map((pool) => {
      let poolAllocation = {
        grantPercentage: "",
        grantAmount: "",
        allShare: false,
      };
      if (allSharesAllPools) {
        poolAllocation.grantPercentage = this.calPercentage(
          amount,
          pool.availableBalance
        );
        poolAllocation.grantAmount = pool.availableBalance;
        poolAllocation.allShare = true;
      }
      return {
        id: pool.poolId,
        name: pool.poolName,
        availableBalance: pool.availableBalance,
        percentShare: pool.percentShare,
        units: pool.units,
        ...poolAllocation,
      };
    });
  };

  /**
   * Weighted Allocation follows a complicated logic as percentShare for pools
   * returned from API may not sum up to 100%.
   * However, amounts needs to total upto the grant amount specified by user.
   */
  createPoolsForWeightedAlloc = (pools, amount, availableBalance) => {
    const enteredAmount = Number(amount);
    let totalCalcAmount = 0;
    let updatedPools = pools.map((pool) => {
      const grantAmount =
        (Number(pool.availableBalance) * enteredAmount) /
        Number(availableBalance);
      totalCalcAmount += Number(grantAmount.toFixed(2));
      return {
        ...pool,
        grantAmount: Number(grantAmount.toFixed(2)),
      };
    });
    totalCalcAmount = Number(totalCalcAmount.toFixed(2));
    // Round 1
    if (totalCalcAmount > enteredAmount) {
      // subtract
      const diff =
        Number(totalCalcAmount).toFixed(2) - Number(enteredAmount).toFixed(2);
      const diffPerPool = (Number(diff) / updatedPools.length).toFixed(2);
      let newTotal = 0;
      updatedPools = updatedPools.map((pool) => {
        const grantAmount =
          pool.grantAmount && Number(pool.grantAmount) - Number(diffPerPool);
        newTotal += Number(grantAmount.toFixed(2));
        return {
          ...pool,
          grantAmount: grantAmount,
        };
      });
      totalCalcAmount = Number(newTotal.toFixed(2));
    } else if (totalCalcAmount < enteredAmount) {
      // add
      const diff =
        Number(enteredAmount).toFixed(2) - Number(totalCalcAmount).toFixed(2);
      const diffPerPool = (Number(diff) / updatedPools.length).toFixed(2);
      let newTotal = 0;
      updatedPools = updatedPools.map((pool) => {
        const grantAmount =
          pool.grantAmount && Number(pool.grantAmount) + Number(diffPerPool);
        newTotal += Number(grantAmount.toFixed(2));
        return {
          ...pool,
          grantAmount: grantAmount,
        };
      });
      totalCalcAmount = Number(newTotal.toFixed(2));
    }

    // Round 2
    if (totalCalcAmount > enteredAmount) {
      // subtract
      let diff = Number(totalCalcAmount - enteredAmount).toFixed(2);
      updatedPools = updatedPools.map((pool) => {
        if (diff && pool.grantAmount) {
          const grantAmount =
            pool.grantAmount && Number(pool.grantAmount) - Number(diff);
          diff = 0;
          return {
            ...pool,
            grantAmount: grantAmount,
          };
        }
        return pool;
      });
    } else if (totalCalcAmount < enteredAmount) {
      // add
      let diff = Number(enteredAmount - totalCalcAmount).toFixed(2);
      updatedPools = updatedPools.map((pool) => {
        if (diff && pool.grantAmount) {
          const grantAmount =
            pool.grantAmount && Number(pool.grantAmount) + Number(diff);
          diff = 0;
          return {
            ...pool,
            grantAmount: grantAmount,
          };
        }
        return pool;
      });
    }

    return updatedPools.map((pool) => {
      return {
        id: pool.poolId,
        name: pool.poolName,
        availableBalance: pool.availableBalance,
        percentShare: pool.percentShare,
        units: pool.units,
        grantPercentage: pool.percentShare,
        grantAmount: !isNaN(pool.grantAmount) && pool.grantAmount.toFixed(2),
        allShare: false,
      };
    });
  };

  prefillTableData = (pools, poolsData, grantAmount, allSharesAllPools) => {
    // Get the selected pool by matching the id
    // If selected pool is all shares, set the entire pool available balance and percent share as grant amount
    return pools.map((pool) => {
      const selectedPool = poolsData.filter((option) => {
        return option.id === pool.poolId;
      });
      const selectedPoolData = selectedPool.length ? selectedPool[0] : {};
      let grPercentage;
      if (allSharesAllPools) {
        grPercentage = pool.percentShare;
      } else if (selectedPoolData.allShare) {
        grPercentage = this.calPercentage(grantAmount, pool.availableBalance);
      } else {
        grPercentage = selectedPoolData.grantPercentage || 0;
      }
      return {
        id: pool.poolId,
        name: pool.poolName,
        availableBalance: pool.availableBalance,
        percentShare: pool.percentShare,
        units: pool.units,
        grantPercentage: grPercentage,
        grantAmount: selectedPoolData.allShare
          ? pool.availableBalance
          : selectedPoolData.grantAmount || 0,
        allShare: selectedPoolData.allShare,
      };
    });
  };

  // on radio button change
  onAllocationRadioChange = (e) => {
    this.setState({
      allocTypeReq: e.target.value,
    });
    // Checking grant amount to check whether reset alert on allocation change should be shown
    let amountFind = find(this.state.grantAllocation, (item) => {
      return item.grantAmount !== "";
    });
    if (amountFind) {
      this.setState({ radioChangePopup: true });
    } else {
      this.handleModalOk();
    }
  };

  // on radio Modal cancelled
  handleModalCancel = () => {
    this.setState({
      radioChangePopup: false,
      allocTypeReq: "",
    });
  };

  // on radio Modal ok
  // reset the data
  handleModalOk = () => {
    const { allocationData, allocationPreference, amount } = this.props;
    this.setState(
      (prevState) => ({
        radioChangePopup: false,
        allocType: prevState.allocTypeReq,
        allocTypeReq: "",
        allShareAllPoolsCheck: false,
        allSharesCheck: false,
        grantAmount: amount,
        grantAllocation: this.createTableData(
          allocationData,
          allocationPreference,
          amount
        ),
      }),
      this.handleChange
    );
  };

  calTotal = (data, field) => {
    const total = data.reduce(
      (acc, row) => Number(acc) + Number(row[field]),
      0
    );
    return Number(total).toFixed(2);
  };

  // on change of grant percentage input
  onGrantPercentageChange = (event, record, allocationPreference) => {
    const { amount } = this.props;
    const changePercent = event.target.value;
    if (regexMap.percentWDecimal.test(changePercent)) {
      this.setState((prevState) => {
        const updatedGrantAllocation = prevState.grantAllocation.map(
          (prevAlloc) => {
            if (record.id === prevAlloc.id) {
              return {
                ...prevAlloc,
                grantPercentage: changePercent,
                grantAmount: this.calBalance(amount, changePercent),
                allShare: false,
              };
            }
            return { ...prevAlloc };
          }
        );
        return {
          grantAllocation: updatedGrantAllocation,
          grantAmountOrPercentFieldChange:
            allocationPreference === "weightedAllocations",
        };
      }, this.handleChange);
    }
  };

  checkPoolValues = () => {
    let check = this.state.grantAllocation.map((item) => {
      if (item.grantAmount) {
        return parseFloat(item.grantAmount) < item.availableBalance;
      }
    });
    return check.includes(false);
  };

  checkAmountLimits = (allocation) => {
    const { name, grantAmount: amount, availableBalance } = allocation;
    this.setState(() => {
      if (amount > availableBalance || this.checkPoolValues()) {
        return {
          activePoolName: "",
          showPoolBalanceExceedError: true,
          showPool90PercentWarning: false,
        };
      } else if ((amount * 100) / availableBalance > 90) {
        return {
          activePoolName: name,
          showPool90PercentWarning: true,
          showPoolBalanceExceedError: false,
        };
      }
      return {
        activePoolName: "",
        showPool90PercentWarning: false,
        showPoolBalanceExceedError: false,
      };
    }, this.handleChange);
  };

  // on change of grant amount input from table
  onGrantAmountChange = (event, record, allocationPreference) => {
    const { amount } = this.props;
    const changeAmount = event.target.value;
    if (regexMap.twoDecimal.test(changeAmount)) {
      this.setState((prevState) => {
        const updatedGrantAllocation = prevState.grantAllocation.map(
          (prevAlloc) => {
            if (record.id === prevAlloc.id) {
              return {
                ...prevAlloc,
                grantPercentage: this.calPercentage(amount, changeAmount),
                grantAmount: changeAmount,
                allShare: false,
              };
            }
            return { ...prevAlloc };
          }
        );
        return {
          grantAllocation: updatedGrantAllocation,
          grantAmountOrPercentFieldChange:
            allocationPreference === "weightedAllocations",
        };
      }, this.handleChange);
    }
  };

  handleChange = () => {
    this.props.onChange(this.formatData());
  };

  calBalance = (availableBalance, percentage) => {
    if (!availableBalance || !percentage) {
      return "";
    }
    return ((availableBalance / 100) * percentage).toFixed(2);
  };

  calPercentage = (totalAmount, singleAmount) => {
    if (!totalAmount || !singleAmount) {
      return "";
    }
    return ((singleAmount / totalAmount) * 100).toFixed(2);
  };

  getCheckedAllshareGrantAllocation = (updatedGrantAllocation) => {
    return filter(updatedGrantAllocation, (each) => {
      return each.allShare;
    });
  };

  // user clicks first induvidual share
  showFirstAllSharePopUp = () => {
    const { grantAllocation } = this.state;
    return (
      this.getCheckedAllshareGrantAllocation(grantAllocation).length === 0 &&
      grantAllocation.length !== 1
    );
  };

  // user checks all induvidual shares
  showAllShareAllsPopUp = () => {
    const { grantAllocation } = this.state;
    return (
      this.getCheckedAllshareGrantAllocation(grantAllocation).length ===
      grantAllocation.length - 1
    );
  };

  // on checkbox change of all share
  onAllShareChange = (event, record) => {
    const { checked } = event.target;
    const { grantAllocation } = this.state;
    if (checked && this.showFirstAllSharePopUp()) {
      this.setState({
        showAllShareFirstPopup: true,
        record,
      });
    } else if (checked && this.showAllShareAllsPopUp()) {
      this.setState({
        showAllPoolsPopup: true,
        fromAllShare: true,
        record,
      });
    } else {
      this.allShareCheckBoxFunctionality(checked, record);
    }
  };

  allShareCheckBoxFunctionality = (checked, record) => {
    let updatedAmount = 0;
    let allSharesCheck = 0;
    this.setState((prevState) => {
      prevState.grantAllocation.forEach((prevAlloc) => {
        if (record.id === prevAlloc.id) {
          // if current pool all share is checked add it, if unchecked then do not add anything
          updatedAmount = checked
            ? updatedAmount + parseFloat(prevAlloc.availableBalance)
            : updatedAmount;
          allSharesCheck = checked ? allSharesCheck + 1 : allSharesCheck;
        } else if (prevAlloc.allShare) {
          // add all pools with all share selected
          updatedAmount = updatedAmount + parseFloat(prevAlloc.grantAmount);
          allSharesCheck += 1;
        }
      });
      const updatedGrantAllocation = prevState.grantAllocation.map(
        (prevAlloc) => {
          // For the selected pool, put entire available balance as grant amount
          if (record.id === prevAlloc.id) {
            return {
              ...prevAlloc,
              grantPercentage: checked
                ? this.calPercentage(updatedAmount, prevAlloc.availableBalance)
                : "",
              grantAmount: checked ? prevAlloc.availableBalance : "",
              allShare: checked,
            };
          }
          // For the other pool, if all share is already selected keep grant amount other make it null
          return {
            ...prevAlloc,
            grantPercentage: prevAlloc.allShare
              ? this.calPercentage(updatedAmount, prevAlloc.grantAmount)
              : "",
            grantAmount: prevAlloc.allShare ? prevAlloc.grantAmount : "",
          };
        }
      );

      return {
        grantAmount: updatedAmount > 0 ? Number(updatedAmount).toFixed(2) : "",
        grantAllocation: updatedGrantAllocation,
        allSharesCheck: allSharesCheck > 0,
        showAllShareFirstPopup: false,
        showAllPoolsPopup: false,
      };
    }, this.handleChange);
  };

  onAllShareAllPoolsChange = (event) => {
    const { checked } = event.target;
    if (checked) {
      this.setState({
        showAllPoolsPopup: true,
        fromAllShare: false,
      });
    } else {
      this.handleAllPoolsCancel({ clearAmount: true });
    }
  };

  handleAllPoolsOk = () => {
    let updatedAmount = this.props.availableBalance;
    this.setState((prevState) => {
      const updatedGrantAllocation = prevState.grantAllocation.map(
        (prevAlloc) => {
          return {
            ...prevAlloc,
            grantPercentage: prevAlloc.percentShare,
            grantAmount: prevAlloc.availableBalance,
            allShare: true,
          };
        }
      );
      return {
        grantAmount: updatedAmount,
        grantAllocation: updatedGrantAllocation,
        showAllPoolsPopup: false,
        allShareAllPoolsCheck: true,
        allSharesCheck: true,
      };
    }, this.handleChange);
  };

  handleAllPoolsCancel = ({ clearAmount = false }) => {
    const { allocationData, allocationPreference, amount } = this.props;
    this.setState(
      {
        showAllPoolsPopup: false,
        allShareAllPoolsCheck: false,
        allSharesCheck: false,
        grantAmount: clearAmount ? "" : amount,

        grantAllocation: this.createTableData(
          allocationData,
          allocationPreference,
          amount
        ),
      },
      this.handleChange
    );
  };

  handleAllSharesOk = () => {
    const { record } = this.state;
    this.allShareCheckBoxFunctionality(true, record);
  };

  handleAllShareCancel = () => {
    this.setState(
      { showAllShareFirstPopup: false, showAllPoolsPopup: false },
      this.handleChange
    );
  };

  renderFooter = () => {
    const { grantAllocation, allocType } = this.state;
    const totalAmount = this.calTotal(grantAllocation, "grantAmount");
    let totalPercent = this.calTotal(grantAllocation, "grantPercentage");
    if (
      this.props.allocationPreference === "weightedAllocations" ||
      allocType === "byDollars" ||
      allocType === "byPercentage"||
      this.state.allShareAllPoolsCheck ||
      this.state.allSharesCheck
    ) {
      // round off the percent if its weighted allocation
      totalPercent =
        Number(totalPercent) > 100
          ? Math.floor(totalPercent)
          : Math.ceil(totalPercent);
    }
    if (this.props.allocationPreference === "entireBalance") {
      return (
        <Row>
          <Col lg={3} push={3} className="hide-md" />
          <Col lg={6} span={9}>
            Total
            <div className="hide-desktop">
              {formatAmount(this.props.availableBalance)}
            </div>
          </Col>
          <Col lg={5} span={0} className="hide-md">
            {formatAmount(this.props.availableBalance)}
          </Col>
          <Col lg={5} span={7}></Col>
          <Col lg={5} span={8}>
            <br className="hide-desktop" />
            {formatAmount(totalAmount)}
          </Col>
        </Row>
      );
    } else {
      return (
        <Row>
          <Col lg={5} span={9}>
            Total
            <div className="hide-desktop">
              {formatAmount(this.props.availableBalance)}
            </div>
          </Col>
          <Col lg={5} span={0} className="hide-md">
            {formatAmount(this.props.availableBalance)}
          </Col>
          <Col lg={4} span={0} />
          <Col lg={5} span={7}>
            {totalPercent}%<div className="content">out of 100%</div>
          </Col>
          <Col lg={5} span={8}>
            {formatAmount(totalAmount)}
            <div className="content">
              {" "}
              out of {formatAmount(this.state.grantAmount)}
            </div>
          </Col>
        </Row>
      );
    }
  };

  keyPropertyFind = () => {
    if (this.props.page === "Grant Agreement")
      return "Pool Change Grant agreement";
    else return "Pool Change Recommend a Grant";
  };

  formatData = () => {
    const filteredAlloc = this.state.grantAllocation.filter(
      (alloc) => alloc.grantAmount > 0 || alloc.grantPercentage > 0
    );
    return {
      allocations: filteredAlloc.map((alloc) => ({
        id: alloc.id,
        name: alloc.name,
        grantAmount: alloc.grantAmount,
        grantPercentage: alloc.grantPercentage,
        units: alloc.allShare ? alloc.units : 0,
        allShare: alloc.allShare,
      })),
      allocType: this.state.allocType,
      grantAmount: this.state.grantAmount,
      allSharesAllPools: this.state.allShareAllPoolsCheck,
      allShares: this.state.allSharesCheck,
      isFormValid: !this.state.showPoolBalanceExceedError,
      grantAmountOrPercentFieldChange: this.state
        .grantAmountOrPercentFieldChange,
    };
  };

  render() {
    const {
      allocationPreference,
      scheduleType,
      availableBalance,
      showAllSharesColumn = true,
      allSharesAllPoolsOnly = false,
      fromEdit = false,
      isGrantAgreement,
      entireBalPopup
    } = this.props;

    const {
      grantAllocation,
      allocType,
      radioChangePopup,
      showAllPoolsPopup,
      allShareAllPoolsCheck,
      allSharesCheck,
      showPool90PercentWarning,
      activePoolName,
      showPoolBalanceExceedError,
      showAllShareFirstPopup,
      fromAllShare,
    } = this.state;

    // All shares all pools should be shown all the time
    const showAllShareAllPools = true;
    const disableAllInputs = allSharesAllPoolsOnly;
    const rowCheked = this.props.allocationPreference === "entireBalance";
    return (
      <div id="grant-table">
        {
          <CustomTable
            className="hide-md"
            dataSource={grantAllocation}
            columns={tabConfigColumn(
              allocationPreference,
              this.onAllocationRadioChange,
              allocType,
              this.onGrantPercentageChange,
              this.onGrantAmountChange,
              this.checkAmountLimits,
              scheduleType,
              allSharesCheck,
              this.onAllShareChange,
              showAllShareAllPools,
              this.onAllShareAllPoolsChange,
              allShareAllPoolsCheck,
              showAllSharesColumn,
              disableAllInputs,
              this.props.isGrantAgreement,
              fromEdit,
              rowCheked,
              entireBalPopup
            )}
            pagination={false}
            allShareRowSelected={this.state.rowSelected}
          />
        }

        {allocationPreference === "entireBalance" && (
          <Row>
            <Col md={24} lg={0} className="mb1">
              {allocationPreference === "entireBalance" &&
                scheduleType === "oneTime" && (
                  <Row>
                    <Col>
                      <DisplayFlex className="ml-10">
                        <GrantAllocationSwitch
                          data-test="allocation-switch"
                          className="mobile-switch"
                          onChange={(checked) =>
                            this.onAllShareAllPoolsChange({
                              target: { checked: checked },
                            })
                          }
                          checked={allShareAllPoolsCheck}
                          disabled={disableAllInputs || entireBalPopup}
                        />
                        <LabelDataHeading className="ml-10">
                          Select all investment options
                        </LabelDataHeading>
                      </DisplayFlex>
                    </Col>
                  </Row>
                )}
            </Col>
          </Row>
        )}

        <Row>
          <Col md={24} lg={0}>
            <GrantAllocationCard
              allocType={allocType}
              allocationPreference={allocationPreference}
              allSharesCheck={allSharesCheck}
              grantAllocation={grantAllocation}
              onGrantAmountChange={this.onGrantAmountChange}
              checkAmountLimits={this.checkAmountLimits}
              onGrantPercentageChange={this.onGrantPercentageChange}
              onAllShareAllPoolsChange={this.onAllShareAllPoolsChange}
              onAllShareChange={this.onAllShareChange}
              scheduleType={scheduleType}
              showAllSharesColumn={showAllSharesColumn}
              disableAllInputs={disableAllInputs}
              allSharesAllPoolsCheck={allShareAllPoolsCheck}
              rowCheked={rowCheked}
            />
          </Col>
        </Row>
        {showPoolBalanceExceedError && (
          <ErrorMsgWrap>
            The recommended grant amount should be less than or equal to your
            current available pool balance. Please edit your grant amount.
          </ErrorMsgWrap>
        )}
        <GrantAllocationFooter>{this.renderFooter()}</GrantAllocationFooter>
        {showPool90PercentWarning && (
          <ErrorPopup
            data-test="pool-percent"
            title="Pool Allocation Change"
            show
            primaryCta={() =>
              this.setState({
                activePoolName: "",
                showPool90PercentWarning: false,
              })
            }
          >
            {!isGrantAgreement ? <SectionContent>
              You have requested more than 90% of {replaceSelect(activePoolName)} pool's
              available balance. We recommend reducing the amount or selecting a different pool with sufficient balance. If you want to continue with this transaction, please click okay.
            </SectionContent>
            : <SectionContent>
            You have requested more than 90% of {replaceSelect(activePoolName)}'s available balance. 
            To ensure funds are available to fulfill the grant agreement,
             we recommend you do not exceed 75% of any individual pools balance. 
             To proceed, please reduce the amount you are drawing from {replaceSelect(activePoolName)}. 
             If you wish to continue with this transaction, please click on OK
          </SectionContent>}
          </ErrorPopup>
        )}
        {radioChangePopup && (
          <ErrorPopup
            title={
              <AlertContent
                page={this.props.page}
                type={[Types.PAGE_ALERTS]}
                keyProperty={this.keyPropertyFind()}
                property={"field_header"}
                html={true}
                defaultMessage={"Confirmation"}
              />
            }
            primaryCtaLabel={
              <AlertContent
                page={this.props.page}
                type={[Types.PAGE_ALERTS]}
                keyProperty={this.keyPropertyFind()}
                property={"field_alert_button1_text"}
                html={true}
                defaultMessage={"Ok"}
              />
            }
            secondaryCtaLabel={
              <AlertContent
                page={this.props.page}
                type={[Types.PAGE_ALERTS]}
                keyProperty={this.keyPropertyFind()}
                property={"field_alert_button2_text"}
                html={true}
                defaultMessage={"Cancel"}
              />
            }
            show={radioChangePopup}
            primaryCta={this.handleModalOk}
            secondaryCta={this.handleModalCancel}
          >
            <AlertWrap>
              <AlertContent
                page={this.props.page}
                type={[Types.PAGE_ALERTS]}
                keyProperty={this.keyPropertyFind()}
                property={"field_description"}
                html={true}
                defaultMessage={
                  "All data entered so far will now be reset. Are you sure?"
                }
              />
            </AlertWrap>
          </ErrorPopup>
        )}
        {showAllPoolsPopup && (
          <ErrorPopup
            title={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"All Share Confirm Recommend a Grant"}
                property={"field_header"}
                html={true}
                defaultMessage={"Alert"}
              />
            }
            show={showAllPoolsPopup}
            primaryCta={this.handleAllPoolsOk}
            secondaryCta={
              fromAllShare
                ? this.handleAllShareCancel
                : this.handleAllPoolsCancel
            }
            primaryCtaLabel={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"All Share Confirm Recommend a Grant"}
                property={"field_alert_button1_text"}
                html={true}
                defaultMessage={"Ok"}
              />
            }
            secondaryCtaLabel={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"All Share Confirm Recommend a Grant"}
                property={"field_alert_button2_text"}
                html={true}
                defaultMessage={"Cancel"}
              />
            }
          >
            <AlertWrap>
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"All Share Confirm Recommend a Grant"}
                property={"field_description"}
                html={true}
                defaultMessage={
                  "<p>Choosing this option will grant the entire available balance of your DAF account. This will close your account once the grant is issued. Click OK to confirm that you wish to grant the entire available account balance and close your DAF account."
                }
              />
            </AlertWrap>
          </ErrorPopup>
        )}
        {showAllShareFirstPopup && (
          <ErrorPopup
            title={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Induvidual Share Alert Recommend a Grant"}
                property={"field_header"}
                html={true}
                defaultMessage={"Alert"}
              />
            }
            show={showAllShareFirstPopup}
            primaryCta={this.handleAllSharesOk}
            secondaryCta={this.handleAllShareCancel}
            primaryCtaLabel={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Induvidual Share Alert Recommend a Grant"}
                property={"field_alert_button1_text"}
                html={true}
                defaultMessage={"Ok"}
              />
            }
            secondaryCtaLabel={
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Induvidual Share Alert Recommend a Grant"}
                property={"field_alert_button2_text"}
                html={true}
                defaultMessage={"Cancel"}
              />
            }
          >
            <AlertWrap>
              <AlertContent
                page={"Recommend a Grant"}
                type={[Types.PAGE_ALERTS]}
                keyProperty={"Induvidual Share Alert Recommend a Grant"}
                property={"field_description"}
                html={true}
                defaultMessage={
                  "<p>Choosing this option will change the grant amount and close the investment option selected. Click OK to confirm that you wish to grant the entire available balance of the selected investment option."
                }
              />
            </AlertWrap>
          </ErrorPopup>
        )}
      </div>
    );
  }
}

GrantAllocationTable.propTypes = {
  allShares: PropTypes.bool,
  allSharesAllPools: PropTypes.bool,
  allSharesAllPoolsOnly: PropTypes.bool,
  allocationData: PropTypes.arrayOf(
    PropTypes.shape({
      allShare: PropTypes.bool,
      availableBalance: PropTypes.number,
      grantAmount: PropTypes.string,
      grantPercentage: PropTypes.number,
      id: PropTypes.number,
      name: PropTypes.string,
      percentShare: PropTypes.number,
      units: PropTypes.number,
    })
  ),
  allocationPreference: PropTypes.string,
  allocations: PropTypes.any,
  amount: PropTypes.string,
  availableBalance: PropTypes.string,
  fromEdit: PropTypes.any,
  onChange: PropTypes.func,
  page: PropTypes.string,
  scheduleType: PropTypes.string,
  showAllSharesColumn: PropTypes.bool,
  weightedAllocEdit: PropTypes.bool,
};
